import { LitElement, html, css } from 'lit'
import SnapScroller from '../../../bui/elements/snap-scroller'

customElements.define('k-snap-scroller', class extends SnapScroller{

    static styles = [SnapScroller.styles,   css`
        :host([fullwidth]) {
            width: 100vw;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            --spacer: calc((100vw - var(--content-w))/2);
            --padding: 1em var(--content-pad);
            max-height: 70vh;
        }

        [name="buttons"] > slot {
            background: var(--bgd);
            font-size: 3em;
        }

        [name="buttons"] > slot:hover {
            background-color: var(--blue-muted);
        }
    `]

})

export default customElements.get('k-snap-scroller')